export function isValidObjectId(id: string): boolean {
  // Check if the id is a string and matches the pattern for a valid ObjectId
  const objectIdRegex = /^[a-fA-F0-9]{24}$/;
  return typeof id === "string" && objectIdRegex.test(id);
}

export function isEmptyObject(obj: unknown): boolean {
  return !!obj && Object.keys(obj).length === 0;
}
